import React from "react";
import CardComponent from "@/components/card";
import "@/styles/components/generalCard.scss";
import Container from "@/components/container/Container";

const GeneralCard = ({ children, className }) => {
  return (
    <Container className={`general-card-wrapper ${className}`}>
      <CardComponent className="card">{children}</CardComponent>
    </Container>
  );
};

export default GeneralCard;
